<template>
  <div>
    <div v-if="!isEdit">
      <div
        style="border-bottom: 4px solid red !important"
        class="shinywhite white--text primary pa-3 text-center"
      >
        <v-avatar size="92px">
          <v-img :src="profile.pictureUrl"></v-img>
        </v-avatar>
        <div>
          คะแนนสะสม
          <span style="font-size: 35px">{{ numberFormat(member.points) }}</span>
          คะแนน
        </div>
        <div
          style="font-size: 10px; font-size: 11px; line-height: 14px;"
          class="pb-2"
        >
          <p class="ma-0">
            คะแนนที่จะหมดอายุ {{ member.points_willexpire }} คะแนน
          </p>
          <p class="ma-0">
            วันที่หมดอายุ
            {{
              moment(member.points_expiredate)
                .add(543, "year")
                .format("DD/MM/YYYY")
            }}
          </p>
        </div>
        <div>
          <v-row>
            <v-col cols="6">
              <v-btn
                style="z-index: 999999999"
                @click="goto('Rewardhistory')"
                block
                rounded
                small
                color="white"
                class="primary--text"
              >
                <img
                  @click="goto('Rewardhistory')"
                  class="mr-1"
                  width="25px"
                  src="@/assets/rewardhistory.png"
                />
                ประวัติแลกคะแนน</v-btn
              >
            </v-col>
            <v-col cols="6">
              <v-btn
                @click="goto('Pointhistory')"
                block
                rounded
                small
                color="white"
                class="primary--text"
              >
                <img
                  @click="goto('Pointhistory')"
                  class="mr-1"
                  width="25px"
                  src="@/assets/pointhistory.png"
                />คะแนนสะสม</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="mt-2 pa-3">
        <div>
          <div style="font-size: 17px" class="py-2">
            <div style="display: flex;align-items: center;">
              <div>
                <v-icon class="mr-5" color="primary" size="40px"
                  >mdi-account</v-icon
                >
              </div>
              <div style="display: flex; flex: 1;">
                <div style="flex: 1;">
                  <div class="pb-1">
                    {{ member.firstName }} {{ member.lastName }}
                  </div>
                  <div style="font-size: 15px">
                    รหัสสมาชิก: {{ member.toa_member_id }}
                  </div>
                </div>
                <div>
                  <v-chip
                    class="ma-2"
                    :color="member.identityNumberImage ? 'green' : 'warning'"
                    text-color="white"
                    small
                  >
                    {{
                      member.identityNumberImage
                        ? "แนบบัตรประชาชนแล้ว"
                        : "ยังไม่ได้แนบบัตรประชาชน"
                    }}
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
        </div>
        <div>
          <div style="font-size: 17px" class="py-2">
            <v-icon class="mr-5" color="primary" size="40px"
              >mdi-calendar</v-icon
            >{{
              moment(member.dob)
                .add(543, "year")
                .format("DD/MM/YYYY")
            }}
          </div>
          <v-divider></v-divider>
        </div>
        <div>
          <div style="font-size: 17px" class="py-2">
            <v-icon class="mr-5" color="primary" size="40px">mdi-phone</v-icon
            >{{ member.phoneNumber }}
            <span
              @click="query.view = 'ChangePhoneNo'"
              style="float: right"
              class="primary--text text-decoration-underline"
              >แก้ไขเบอร์โทร</span
            >
          </div>
          <v-divider></v-divider>
        </div>
        <div>
          <div style="font-size: 17px" class="py-2">
            <v-icon class="mr-5" color="primary" size="40px">mdi-email</v-icon
            >{{ member.email || "-" }}
          </div>
          <v-divider></v-divider>
        </div>
        <div>
          <div style="font-size: 17px" class="py-2">
            <v-icon class="mr-5" color="primary" size="40px"
              >mdi-bag-checked</v-icon
            >{{ member.job }}
          </div>
          <v-divider></v-divider>
        </div>
        <div>
          <v-btn
            @click="isEdit = true"
            class="mt-5"
            style="font-size: 17px"
            block
            color="primary"
            ><v-icon class="mr-2" color="white">mdi-pencil</v-icon>แก้ไข</v-btn
          >
          <div>
            <v-btn
              class="mt-3"
              color="red"
              block
              text
              @click="gotochangepassword"
            >
              เปลี่ยนรหัสผ่าน
            </v-btn>
          </div>
          <div>
            <v-btn
              class="mt-3"
              color="primary"
              block
              text
              style="text-decoration: underline;"
              @click="viewTermsAndConditions"
            >
              นโยบายความเป็นส่วนตัว
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <ProfileEdit @close="isEdit = false"></ProfileEdit>
    </div>
  </div>
</template>

<script>
import ProfileEdit from "./ProfileEdit/main.vue";
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      isEdit: false,
    };
  },
  components: {
    ProfileEdit,
  },
  computed: {
    moment() {
      return moment;
    },
    member() {
      return this.$store.state.member;
    },
  },
  mounted() {},
  methods: {
    gotochangepassword() {
      this.$store.state.redirectview = this.query.view;
      this.query.view = "ForgetPassword";
    },
    goto(item) {
      this.$store.state.redirectview = "PointManager";
      this.query.view = item;
    },
    viewTermsAndConditions() {
      this.$store.state.isCancelPdpa = true;
      this.$store.state.redirectview = this.query.view;
      this.query.view = "TermsAndConditions";
    },
  },
};
</script>

<style lang="scss" scoped></style>
